import { css } from "@emotion/react";

import { theme } from "shared/lib/styles";

export const headerFontSizes = {
  desktop: "14px",
  mediumDesktop: "15px",
} as const;

export const setResponsiveHeaderFontSize = () => css`
  ${theme.breakpoints.up("desktop")} {
    font-size: ${headerFontSizes.desktop};
  }
  ${theme.breakpoints.up("mediumDesktop")} {
    font-size: ${headerFontSizes.mediumDesktop};
  }
`;
